import InviteCode from "./InviteCode";
export default InviteCode;
